import {SuggestAction} from '@yandex-delivery/api/model/suggest'

import type {SuggestRepository} from '../../repo/suggest/types'
import {toAddressesSuggest} from './mappers/to-address-suggest'
import {toSuggestBody} from './mappers/to-suggest-body'
import type {SuggestService} from './type'
import {checkServiceAvailability} from './utils'

export * from './type'

export function createSuggestService(phoenixRepository: SuggestRepository): SuggestService {
  const {fetchSuggest} = phoenixRepository

  return {
    fetchAddressSuggest(params) {
      const body = toSuggestBody(params)
      return fetchSuggest(body).then(checkServiceAvailability).then(toAddressesSuggest(body))
    },
    fetchInternationalNddAddress(params) {
      const body = toSuggestBody({
        ...params,
        currentMode: 'delivery_ndd_international',
        action: SuggestAction.PIN_DROP,
      })
      return fetchSuggest(body)
        .then(checkServiceAvailability)
        .then(toAddressesSuggest(body))
        .then(response => {
          const data = response.suggest?.[0]?.__origin
          if (!data) {
            return null
          }
          return data
        })
    },
  }
}
